<template>

  <select v-if="!multiple" class="form-control" :name="name" v-model="value">
    <option value="">Select an option...</option>
    <option v-for="option in options" :value="option.id">{{ option.text }}</option>
  </select>

  <chosen v-else
    v-model="value"
    :name="name"
    :options="options"
    label="text"
    trackBy="id"
    :multiple="multiple">
  </chosen>

</template>

<script>
  import EditableField from "./EditableField";

  export default {
    mixins: [EditableField],

    props: {
      modelValue: {type: [String, Number, Date, Array], default: ''},
      options: {type: Array, default: () => []},
      multiple: {type: Boolean, default: false},
    },
  }
</script>
